import * as React from "react";
import { createPortal } from "react-dom";

import { useTransition, animated } from "@react-spring/web";
import styles from "../addToCart.module.scss";

interface ModalBackdropProps {
  open: boolean;
  children?: React.ReactNode;
  onClose: () => void;
}

const Modal: React.FC<ModalBackdropProps> = (props) => {
  const justAddedRef = React.useRef<HTMLDivElement>(null);

  const transition = useTransition(props.open, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const slideIn = useTransition(props.open, {
    from: { y: "100%" },
    enter: { y: "0%" },
    leave: { y: "100%" },
  });

  const drawer = document.querySelector("#cart-drawer");
  if (!drawer) {
    return <></>;
  }

  return (
    <>
      {createPortal(
        <>
          {transition((style, item) =>
            item ? (
              <animated.div
                style={style}
                className={styles["modal-backdrop"]}
                onClick={props.onClose}
              />
            ) : (
              ``
            )
          )}

          {slideIn((style, item) =>
            item ? (
              <animated.div
                style={style}
                ref={justAddedRef}
                className={styles["cart-drawer"]}
              >
                {props.children}
              </animated.div>
            ) : (
              ""
            )
          )}
        </>,
        drawer
      )}
    </>
  );
};

export default Modal;
